module.exports = __webpack_public_path__ + "static/media/User_Guide_Serra_Labs.69836967.pdf";